import { useEffect } from 'react'
import Navbar from '../../components/landingPage/Navbar/Navbar.jsx'
import { Outlet, useLocation } from 'react-router-dom'
import './HomePageLayout.css'
import LandingPageFooter from '../../pages/home/footer/LandingPageFooter.jsx'

const HomePageLayout = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    sessionStorage.removeItem('isLoggingOut')
  }, [pathname])

  return (
    <div className='digikelz-main-container'>
      <Navbar />
      <main
        id='main-content'
        className='digipalz-landing-page-content'
        role='main'
      >
        <Outlet />
      </main>
      <LandingPageFooter />
    </div>
  )
}

export default HomePageLayout
